export default __webpack_public_path__ + "static/media/itago-screenshot-04.08efa790.png";